import { all, fork, put, takeEvery, call } from "redux-saga/effects";
import { SagaIterator } from "@redux-saga/core";

// constants
import { OffersActionTypes } from "./constants";
import { getOffersAction, OffersApiResponseError, OffersApiResponseSuccess } from "./actions";
import { addOfferApi, deleteOfferApi, getOffersApi, updateOfferApi } from "../../helpers/api/offers";

// Fetch Offers saga
function* getOffersSaga(): SagaIterator {
  try {
    const response = yield call(getOffersApi);
    const offers = response?.data?.data?.offers;

    yield put(OffersApiResponseSuccess(OffersActionTypes.GET_OFFERS, offers));
  } catch (error: any) {
    yield put(OffersApiResponseError(OffersActionTypes.GET_OFFERS, error));
  }
}

// Update offer saga
function* updateOfferSaga({ payload: { id, description, order, status } }: any): SagaIterator {
  try {
    const response = yield call(updateOfferApi, { id, description, order, status });
    const message = response?.data?.message;

    yield put(OffersApiResponseSuccess(OffersActionTypes.UPDATE_OFFERS, message));
    yield put(getOffersAction());
  } catch (error: any) {
    yield put(OffersApiResponseError(OffersActionTypes.UPDATE_OFFERS, error));
  }
}

// Add new offer saga
function* addOfferSaga({ payload: { description, order, status } }: any): SagaIterator {
  try {
    const response = yield call(addOfferApi, { description, order, status });
    const message = response?.data?.message;

    yield put(OffersApiResponseSuccess(OffersActionTypes.ADD_OFFERS, message));
    yield put(getOffersAction());
  } catch (error: any) {
    yield put(OffersApiResponseError(OffersActionTypes.ADD_OFFERS, error));
  }
}

// Delete offer saga
function* deleteOfferSaga({ payload: { id } }: any): SagaIterator {
  try {
    const response = yield call(deleteOfferApi, { id });
    const message = response?.data?.message;

    yield put(OffersApiResponseSuccess(OffersActionTypes.DELETE_OFFERS, message));
    yield put(getOffersAction());
  } catch (error: any) {
    yield put(OffersApiResponseError(OffersActionTypes.DELETE_OFFERS, error));
  }
}

// Watchers
export function* watchGetOffers() {
  yield takeEvery(OffersActionTypes.GET_OFFERS, getOffersSaga);
}

export function* watchUpdateOffer() {
  yield takeEvery(OffersActionTypes.UPDATE_OFFERS, updateOfferSaga);
}

export function* watchAddOffer() {
  yield takeEvery(OffersActionTypes.ADD_OFFERS, addOfferSaga);
}

export function* watchDeleteOffer() {
  yield takeEvery(OffersActionTypes.DELETE_OFFERS, deleteOfferSaga);
}

// Root saga
function* OffersSaga() {
  yield all([fork(watchGetOffers), fork(watchUpdateOffer), fork(watchAddOffer), fork(watchDeleteOffer)]);
}

export default OffersSaga;
